// src/store/useAddressStore.js
import { create } from "zustand";
import { axiosInstancev1 } from "../lib/axiosInstance";
// Removed useAuthStore as it's not needed for these public address APIs
import { toast } from "react-hot-toast";

const useAddressStore = create((set, get) => ({
  // states: [], // Removed as state is defaulted to Tamil Nadu for this context
  districts: [],
  taluks: [],
  // isLoadingStates: false, // Removed
  isLoadingDistricts: false,
  isLoadingTaluks: false,
  error: null,

  // fetchStates is removed as it's not needed if state is defaulted

  fetchMappedDistricts: async (stateName = "Tamil Nadu") => { // Default to Tamil Nadu
    set({ isLoadingDistricts: true, error: null, districts: [], taluks: [] }); // Clear previous
    try {
      // API endpoint for districts usually takes state as a query param
      // If your API doesn't need 'state' when it's Tamil Nadu, you can omit it.
      const response = await axiosInstancev1.get(`/address/mapped-districts?state=${encodeURIComponent(stateName)}`);
      set({ districts: response.data?.districts || [], isLoadingDistricts: false });
    } catch (err) {
      const errorMsg = err.response?.data?.message || `Failed to fetch districts for ${stateName}.`;
      set({ error: errorMsg, isLoadingDistricts: false, districts: [] });
      toast.error(errorMsg);
    }
  },

  fetchMappedTaluks: async (districtName, stateName = "Tamil Nadu") => { // Default to Tamil Nadu
    if (!districtName) {
      set({ taluks: [] }); // Clear dependent dropdown
      return;
    }
    set({ isLoadingTaluks: true, error: null, taluks: [] }); // Clear previous
    try {
      const response = await axiosInstancev1.get(
        `/address/mapped-taluks?state=${encodeURIComponent(stateName)}&district=${encodeURIComponent(districtName)}`
      );
      set({ taluks: response.data?.taluks || [], isLoadingTaluks: false });
    } catch (err) {
      const errorMsg = err.response?.data?.message || `Failed to fetch taluks for ${districtName}.`;
      set({ error: errorMsg, isLoadingTaluks: false, taluks: [] });
      toast.error(errorMsg);
    }
  },
}));

export default useAddressStore;